import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { manufacturingService } from "../../services/manufacturing.service";
import { Modal } from "../ui/Modal";
import { getApiErrorMessage } from "../ui/FormControls";
import WorkOrderForm, { WorkOrderFormValues } from "./WorkOrderForm";
import toast from "react-hot-toast";

interface AddManufacturingOrderModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AddManufacturingOrderModal: React.FC<AddManufacturingOrderModalProps> = ({
  isOpen,
  onClose,
}) => {
  const queryClient = useQueryClient();


  const createMutation = useMutation({
    mutationFn: manufacturingService.createWorkOrder,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["workOrders"] });
      onClose();
      toast.success("Manufacturing order created successfully");
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error, "Could not create the manufacturing order"));
    },
  });

  const handleSubmit = ({ status, ...values }: WorkOrderFormValues) => {
    createMutation.mutate(values);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Add Manufacturing Order"
      description="Plan a production run for a product."
      size="2xl"
    >
      <WorkOrderForm
        defaultWorkOrderNumber=""
        onSubmit={handleSubmit}
        onCancel={onClose}
        isPending={createMutation.isPending}
      />
    </Modal>
  );
};

export default AddManufacturingOrderModal;
